import { axiosLasta } from 'config';

export const getFeatureFlagConfig = async () => {
    const response = await axiosLasta('/feature-flag/all');
    const { data } = response;
    return data;
};
